
<section v-if="multiplierCards.length > 0 && card.collectionCardId" class="card-profile-multipliers">
  <align class="section-header">
    <h4 class="secondary-font">
      Multipliers
    </h4>

    <icon-button
      tooltip="Edit Multipliers"
      class="edit"
      icon="edit"
      @click="edit"
    />
  </align>

  <template v-if="multiplierCards.length > 0">
    <div class="list">
      <card-list-item
        v-for="multiplier in multiplierCards"
        :key="multiplier.id"
        :card="multiplier"
        :fields="['currentValue']"
        :custom-fields="[{
          label: 'Multiplier',
          value: `${$filters.decimal(multiplier.value)}x`,
        }]"
        :to="{ name: $route.name, params: { ...$route.params, id: multiplier.card }, query: { ...$route.query, profile: 'ladder' } }"
        as="router-link"
      />
    </div>
  </template>
</section>
